import React from 'react';
import { PictureIcon } from '../../../assets/icons'
import { Translate } from '../../../language';
import { Switch } from 'react-router-dom'
import { useHistory } from "react-router-dom";
import { RouteWithSubRoutes } from "../../../config/Router";
import ButtonCircle from '../../../utils/components/ButtonCircle/ButtonCircle';
import Button from '../../../utils/components/Button/Button';
import style from './ListRooms.module.css'
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';
import { clearRoom } from '../../../actions/userActions';
import { useDispatch } from 'react-redux';

const ListRooms = ({ membersRoom, routes = [], rooms, categories, myRooms, roomsIBelong, allMyRooms }) => {


    const history = useHistory()
    const dispatch = useDispatch()
    return (
        <div className={style.content_general}>
            <div className={style.content_left}>
                <div className={style.content_icon}><PictureIcon className={style.icon} /></div>
                <div className={style.content_list_rooms}>
                    <div className={style.title}>
                        {Translate('chatRooms', 'es')}
                        <div className={style.purple}>{Translate('available', 'es')}</div>
                    </div>
                    <div onClick={() => {
                        history.push("/Rooms/NewRoom")
                    }}
                        className={style.create}>
                        <ButtonCircle />
                        {Translate('createChatRoom', 'es')}
                    </div>
                    {
                        rooms.map(room => (
                            <Button
                                onClick={() => {
                                    if (allMyRooms.filter(e => e._id === room._id).length > 0) {
                                        /* vendors contains the element we're looking for */
                                        history.push("/Rooms/Room/" + room._id)
                                    } else {
                                        history.push("/Rooms/Join/" + room._id)
                                    }
                                    //  history.push("/Rooms/Room/" + room._id)
                                }}
                                text={room.name} classNameContent={style.content_button} theme={'white'} />
                        ))
                    }
                    <div className={style.list_item}>
                        {/*  {['list', 'mensajes', 'amigos'].map(() =>

                            <ImageNameDescription
                                type={"header-message"}
                                srcImage={localStorage().getItem("picturProfile")}
                                firstName={localStorage().getItem("nameUser") && localStorage().getItem("nameUser").split(' ')[0]}
                                secondName={localStorage().getItem("nameUser") && localStorage().getItem("nameUser").split(' ')[1]}
                                description={"Hola, como estas?"}
                                options={[{ text: 'Eliminar', onClick: () => { } }, { text: 'Reportar', onClick: () => { } }]}
                            />

                        )} */}
                    </div>
                    <Button text={'Mis salas'} classNameContent={style.content_button} />
                    <div className={style.list_item}>
                        {myRooms.map((room) =>
                            <ImageNameDescription
                                onClick={(e) => {
                                    e.preventDefault(); e.stopPropagation();
                                    //console.log();
                                    dispatch(clearRoom())
                                    history.push("/Rooms/Room/" + room._id)
                                }}
                                type={"header-message"}
                                srcImage={room.profilePicture && room.profilePicture.url && room.profilePicture.url.origin}
                                firstName={room.name}
                                typeOneText=""
                            />
                        )}
                    </div>
                    <Button text={'Salas a las que pertenezco'} classNameContent={style.content_button} />
                    <div className={style.list_item}>
                        {roomsIBelong.map((room) =>
                            <ImageNameDescription
                                onClick={(e) => {
                                    e.preventDefault(); e.stopPropagation();
                                    //console.log();
                                    dispatch(clearRoom())
                                    history.push("/Rooms/Room/" + room._id)
                                }}
                                type={"header-message"}
                                srcImage={room.profilePicture && room.profilePicture.url && room.profilePicture.url.origin}
                                firstName={room.name}
                                typeOneText=""
                            />
                        )}
                    </div>
                    <Button text={'Categorias'} classNameContent={style.content_button} theme={'white'} />
                    <div className={style.list_item}>
                        {categories.map((category) =>
                            <div onClick={() => {
                                history.push({
                                    pathname: '/Rooms/Category/' + category._id,
                                })
                            }}>
                                {category.name}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className={style.content_right}>
                <Switch>
                    {routes.map((route, i) => (
                        <RouteWithSubRoutes key={i} {...route} />
                    ))}
                </Switch>
            </div>
        </div>
    );
};

export default ListRooms;
